// Tailwind classes for site context pills (matches Sites#color_token).
// REVERT NOTE (2026 palette swap): `pre-2026:` marks the ring accent used before
// the swap. See KOLORY-STAN-OBECNY.md.
const SITE_CONTEXT_BADGE_CLASSES = {
  'code-medical-center': 'bg-code-medical-center-secondary text-code-medical-center ring-cyan-200/80', // pre-2026: ring-sky-200/80
  'infertility-clinic': 'bg-infertility-clinic-secondary text-infertility-clinic ring-sky-200/80', // pre-2026: ring-fuchsia-200/80
  institute: 'bg-institute-secondary text-institute ring-cyan-200/80', // pre-2026: ring-violet-200/80
  'family-clinic': 'bg-family-clinic-secondary text-family-clinic ring-emerald-200/80', // pre-2026: ring-teal-200/80
};

export function badgeClassesForContextColor(colorToken) {
  return SITE_CONTEXT_BADGE_CLASSES[colorToken] || 'bg-gray-100 text-gray-700 ring-gray-200/80';
}
